<template>
  <div id="app">
    <el-container v-if="this.$route.name !== 'login'">
      <el-aside :class="this.$route.name == 'login' ? 'inLogin' : ''">
        <Side></Side>
      </el-aside>
      <el-container>
        <el-header :class="this.$route.name == 'login' ? 'inLogin' : ''">
            <el-tooltip content="Api Document" placement="bottom" effect="light">
              <span class="el-icon-info  apidocument"  @click="goApidocument"></span>
            </el-tooltip>
          <div class="name">{{ channel_email }}</div>
          <el-button round size="mini" @click="logout">Logout</el-button>
        </el-header>
        <el-main><router-view></router-view></el-main>
      </el-container>
    </el-container>
    <el-container v-else>
      <Login></Login>
    </el-container>
  </div>
</template>

<script>
import Side from "@/views/channelClient/side.vue";
import Login from "@/views/channelClient/login.vue";

import { post } from "@/lib/channelClient";
export default {
	data() {
		return {
			channel_email: localStorage.getItem("channel_email"),
		};
	},
	name: "app",
	components: {
		Side,
    Login,
	},
	methods: {
		async logout() {
			await post("/channelClient/logout", {});
			window.location.href = "/login";
		},
		goApidocument(){
			window.open("https://www.little9.top/apiDocument.html")
		}
	},
};
</script>

<style>
body,
html,
.el-container,
#app {
  height: 100%;
  width: 100%;
  margin: 0;
  font-weight: 400;
  font-size:14px;
  /* font-family: nunito-sans-bold; */
}
.utc{
  margin-right:10px;
}
.name {
  color: white;
  font-size: 14px;
  margin-right: 20px;
}
.el-header {
  display: flex;
  height: 150;
  padding-top: 20px;
  background-color: rgb(74, 121, 184);
  justify-content: flex-end;
  align-items: center;
}
.inLogin {
  pointer-events: none;
  filter: blur(4px);
}

.el-aside {
  background-color: rgb(50, 90, 144);
  color: #333;
  text-align: center;
  width:200px !important;
}

.el-main {
  background-color: rgb(240, 240, 240);

  color: #333;
}

.status-paid,
.status-confirm {
  color: #67c23a;
}
.status-deducted {
  color: crimson;
}

.el-pagination button,.el-pager li{
background-color: transparent !important;
}
.container {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}


.report {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.header {
  display: flex;
  align-items: center;
  background-color: #495668;
  color: white;
  height: 40px;
}

.searchCondition {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
}
.tip {
  margin-left: 30px;
  height: 40px;
}
/* .report>.el-table{
  font-size: 12px;
} */
.table-header {
  height: 30px;
  color: rgb(30, 30, 30);
}
.el-pagination__sizes,.el-pagination__sizes>div,.el-pagination__sizes>div>div,.el-pagination__sizes>div>div>input{
  background-color: transparent !important;
}

.el-table td, .el-table th{
  padding:8px 0;
}

.apidocument{
  color:white;
  font-size:24px;
  margin-right: 20px;
  cursor: pointer;
}
.apidocument:hover{
  color:#409EFF;
}
</style>
